module.exports = __webpack_public_path__ + "img/avt.275d7506.png";